import React from 'react';
import { Settings } from 'lucide-react';
import { SnapshotDateConfig } from './SnapshotDateConfig';

export const ConfigTab: React.FC = () => {
  return (
    <div className='space-y-6'>
      {/* Header */}
      <div className='flex items-center gap-3'>
        <div className='p-3 bg-primary/10 rounded-lg'>
          <Settings className='h-6 w-6 text-primary' />
        </div>
        <div>
          <h2 className='text-2xl font-bold tracking-tight'>Configuration</h2>
          <p className='text-muted-foreground'>Manage system-wide configuration settings</p>
        </div>
      </div>

      {/* Configuration Grid */}
      <div className='grid grid-cols-4 gap-6'>
        {/* Snapshot Date Configuration - Column 1 */}
        <div className='space-y-2'>
          <h3 className='text-sm font-medium text-muted-foreground'>Data Snapshot</h3>
          <SnapshotDateConfig />
        </div>

        {/* Future Configuration Sections - Columns 2-4 */}
        <div className='space-y-2'>
          <h3 className='text-sm font-medium text-muted-foreground'>Feature Flags</h3>
          <div className='text-xs text-muted-foreground'>Coming soon...</div>
        </div>

        <div className='space-y-2'>
          <h3 className='text-sm font-medium text-muted-foreground'>User Settings</h3>
          <div className='text-xs text-muted-foreground'>Coming soon...</div>
        </div>

        <div className='space-y-2'>
          <h3 className='text-sm font-medium text-muted-foreground'>System</h3>
          <div className='text-xs text-muted-foreground'>Coming soon...</div>
        </div>
      </div>
    </div>
  );
};
